'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-undef: "off" */
/**
 * blog list container
 */
define('blogListMain',['getSpecialLisaApi', 'util'], function (getSpecialLisaApi, Util) {
  return {
    template: '\n      <div class="main-container in-container">\n        <div class="in-blog-list-container">\n          <div class="in-ads-title">\n            <h2 v-text="i18n.topicPage" class="font-helNenu67"></h2>\n            <hr class="in-ads-hr" />\n          </div>\n\n          <div class="in-blog-list" v-if="blogList.length > 0">\n            <div class="in-blog-left" v-if="blogList.length > 0">\n              <div class="in-blog" v-for="item in blogList">\n                <a :href="item.url">\n                  <img v-lazy="item.image"/>\n                </a>\n                <div class="in-blog-short-info">\n                  <a :href="item.url">\n                    <h6 class="font-openSansB" v-text="item.name"></h6>\n                  </a>\n                  <p v-text="item.short_description"></p>\n                </div>\n              </div>\n            </div>\n            <div class="in-blog-topic" v-if="blogTopicList.length > 0">\n              <h6 class="in-title" v-text="i18n.popularArticles"></h6>\n              <ul>\n                <li v-for="item in blogTopicList">\n                  <a :href="item.url">\n                    <img v-lazy="item.image"/>\n                  </a>\n                  <h6 class="in-title" v-text="item.name"></h6>\n                </li>\n              </ul>\n            </div>\n          </div>\n\n          <div class="in-not-found-page" v-if="blogList.length == 0">\n            <i class="in-icon-empty-results"></i>\n            <p class="in-404-note" v-text="i18n.noResult + \'.\'"></p>\n            <div class="in-btn">\n              <a href="/" v-text="i18n.home"></a>\n            </div>\n          </div>\n\n        </div>\n\n        <div class="in-g-loading" v-show="isGetDataStatus">\n          <div class="in-loadmore" v-show="isLoadingShow"></div>\n          <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="scrollDistance" ></div>\n        </div>\n\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          topicPage: 'TOPIC PAGE',
          popularArticles: 'POPULAR ARTICLES',
          home: 'Home',
          noResult: 'Sorry, No results were found'
        },
        blogList: [],
        blogTopicList: [],
        isPageShow: false,
        isLoadingShow: false,
        busy: false,
        scrollDistance: 900,
        page: 2,
        pageSize: 10,
        isGetDataStatus: false
      };
    },
    mounted: function mounted() {
      this.init();
    },

    methods: {
      init: function init() {
        if (window.blogListDataJSON.ret_code === 200) {
          this.blogList = window.blogListDataJSON.data.lists;
          this.blogList.length >= 10 ? this.isGetDataStatus = true : this.isGetDataStatus = false;
          this.blogTopicList = window.blogListDataJSON.data.recommend;
        }
      },

      /**
       * loadmore 加载
       */
      loadMore: function loadMore() {
        var _this = this;

        if (this.isGetDataStatus) {
          this.isLoadingShow = true;
          this.busy = true;

          setTimeout(function () {
            _this.getSpeciaList();
          }, 500);
        }
      },
      getSpeciaList: function getSpeciaList() {
        var _this2 = this;

        getSpecialLisaApi({
          page: this.page,
          page_size: this.pageSize
        }).then(function (resData) {
          _this2.busy = false;
          return _this2.updateBlogList(resData);
        });
      },
      updateBlogList: function updateBlogList(data) {
        this.blogList = [].concat(_toConsumableArray(this.blogList), _toConsumableArray(data.list));
      }
    }
  };
});
